export default customElements.define('w-search-select', class SearchSelect extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-search-select',
            templateHTML: `
            <div class="c-search-select__container" data-root>
                <span data-slot="input" class="c-search-select__input" data-input></span>
                <datalist class="c-search-select__datalist" id="search-select-options" data-datalist></datalist>
            </div>`,
            cacheDom: [ 'data-datalist', 'data-input'],
            defaultSlotContents: {input: '<w-textbox data-slot="input" key="textbox" class="c-search-select__input" data-slot-required data-input></w-textbox>'},
        };

        super(config);

        this.filteredOptions = [];
        this.Direction = Object.freeze({
            'Up': 0,
            'Down': 1
        });

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            
            this.dom.input.autocomplete = false;
            this.storedInput = '';

            this.dom.datalist.classList.add('u-display__none');

            this.dom.datalist.addEventListener('mouseenter', () => {
                this.mouseOverOptions = true;
            });

            this.dom.datalist.addEventListener('mouseleave', () => {
                this.mouseOverOptions = false;
            });

            this.dom.input.addEventListener('click', () => {
                this._showOrHideOptions();
            }, true);

            this.dom.input.addEventListener('focus', () => {
                this._showOrHideOptions();
            }, true);
            
            this.dom.input.addEventListener('blur', () => {
                this._resetHighlighted();

                if (!this.mouseOverOptions){
                    this.dom.datalist.classList.add('u-display__none');
                }
            }, true);

            this.dom.input.addEventListener('valuechange', this._updateOptions.bind(this));

            this.dom.input.addEventListener('keydown', this._navigateOptions.bind(this));
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('datalistoptions'),
            new wealthify.Prop('filteroptions', {
                default: true,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('value'),
            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks () {
        return {
            datalistoptions: () => this._updateOptionsList(),

            filteroptions: () => {},

            value: () => {
                this.dom.input.value = this.value; 
            }
        };
    }

    _updateOptions() {
        if (this.dom.input.value === this.storedInput) {
            return;
        }

        this._updateOptionsList();
        this.storedInput = this.dom.input.value;
        this.value = this.dom.input.value;
        this._showOrHideOptions();
    }

    _updateOptionsList() {
        if (this.datalistoptions === undefined) {
            this.datalistoptions = [];
        }

        const inputValue = this.dom.input.value || '';

        this.dom.datalist.innerHTML = '';

        this.filteredOptions =
            this.filteroptions ? this.datalistoptions.filter(option => option.toLowerCase().includes(inputValue.toLowerCase())) : this.datalistoptions;

        for(let option in this.filteredOptions) {
            let optionElement = document.createElement('OPTION');

            optionElement.classList.add('c-search-select__datalist-option');
            optionElement.setAttribute('value', this.filteredOptions[option]);
            optionElement.innerHTML = this.filteredOptions[option];

            optionElement.addEventListener('click', this._optionOnClick.bind(this, optionElement));

            this.dom.datalist.appendChild(optionElement);
        }
    }

    _optionOnClick(optionElement) {

        this._resetHighlighted();

        optionElement.selected = true;

        this.storedInput = this.value = this.dom.input.value = optionElement.value;
        
        this.dom.datalist.classList.add('u-display__none');
    }

    _navigateOptions(event) {
        if (!this.dom.datalist.classList.contains('u-display__none')) {
            let options = this.dom.datalist.children;

            let currentSelected;
            
            let currentHighlighted;

            for (let index = 0; index < options.length; index++) {

                if (options[index].selected) {
                    currentSelected = index;
                }

                if (options[index].highlighted) {
                    currentHighlighted = index;
                }
            }

            if (currentHighlighted === undefined && currentSelected !== undefined){
                currentHighlighted = currentSelected;
            }

            // If the arrow DOWN key is pressed
            if (event.keyCode == 40) {
                if (currentHighlighted === undefined) {
                    currentHighlighted = options.length - 1;
                }

                this._updateHighlighted(currentHighlighted, this.Direction.Down);

            // If the arrow UP key is pressed
            } else if (event.keyCode == 38) {
                if (currentHighlighted === undefined) {
                    currentHighlighted = 0;
                }

                this._updateHighlighted(currentHighlighted, this.Direction.Up);

            // If the ENTER key is pressed
            } else if (event.keyCode == 13) {
                event.preventDefault();

                this._optionOnClick(options[currentHighlighted]);
            }
        }
    }

    _updateHighlighted(currentHighlighted, direction) {
        let options = this.dom.datalist.children;

        options[currentHighlighted].highlighted = false;
        options[currentHighlighted].classList.remove('c-search-select__datalist-option--active');

        if (direction === this.Direction.Up) {
            currentHighlighted = currentHighlighted === 0 ? options.length - 1 : currentHighlighted - 1;
        } else {
            currentHighlighted = currentHighlighted === options.length - 1 ? 0 : currentHighlighted + 1;
        }

        options[currentHighlighted].highlighted = true;
        options[currentHighlighted].classList.add('c-search-select__datalist-option--active');
    }

    _resetHighlighted() {
        let options = this.dom.datalist.children;

        for (let index = 0; index < options.length; index++) {
            options[index].highlighted = false;
            options[index].classList.remove('c-search-select__datalist-option--active');
        }
    }

    _showOrHideOptions() {
        let classListAction = (this.filteredOptions && this.filteredOptions.length > 0) ? 'remove' : 'add';
        
        this.dom.datalist.classList[classListAction]('u-display__none');
    }
});